import React from 'react';
import { theme } from 'codeArt/components/Base';
import { DataContext } from './context';
import { DeviceType } from 'app/constant';
import { getRandom } from 'app/components/common';
import { Util } from 'codeArt/common';
import { threePosition } from '../../codeArt/common';

//在当前页面的路由表页面进行调用 否则不进行触发调用
export function importData() {
    DataContext.register([
        {
            name: "STOCK_HOME_NUMBER",
            data: STOCK_HOME_NUMBER
        }
    ]);
}

const STOCK_HOME_NUMBER = [
    [
        { name: "爆珠棒", value: 4535, color: theme.color.primary, type:"爆珠棒", format: (v,name) => { return {name:name,value:threePosition(v)}} },
        { name: "高透棒", value: 1498, color: theme.color.warning, type:"高透棒", format: (v,name) => { return {name:name,value:threePosition(v)}}  },
        { name: "中空拉丝棒", value: 3603, color: theme.color.pink, type:"中空拉丝棒", format: (v,name) => { return {name:name,value:threePosition(v)}}  },
        { name: "二元复合棒", value: 3726, color: theme.color.danger, type:"二元复合棒", format: (v,name) => { return {name:name,value:threePosition(v)}}  },
        { name: "三元复合棒", value: 1500, color: theme.color.green, type:"三元复合棒", format: (v,name) => { return {name:name,value:threePosition(v)}}  },
        { name: "四元复合棒", value: 5698, color: theme.color.gray, type:"四元复合棒", format: (v,name) => { return {name:name,value:threePosition(v)}}  }
    ],
    [
        { name: "爆珠棒", value: 3987, color: theme.color.primary, type:"爆珠棒" , format: (v,name) => { return {name:name,value:threePosition(v)}}},
        { name: "高透棒", value: 3532, color: theme.color.warning, type:"高透棒", format: (v,name) => { return {name:name,value:threePosition(v)}}   },
        { name: "中空拉丝棒", value: 1603, color: theme.color.pink, type:"中空拉丝棒", format: (v,name) => { return {name:name,value:threePosition(v)}}   },
        { name: "二元复合棒", value: 2726, color: theme.color.danger, type:"二元复合棒", format: (v,name) => { return {name:name,value:threePosition(v)}}  },
        { name: "三元复合棒", value: 3500, color: theme.color.green , type:"三元复合棒", format: (v,name) => { return {name:name,value:threePosition(v)}} },
        { name: "四元复合棒", value: 2698, color: theme.color.gray, type:"四元复合棒" , format: (v,name) => { return {name:name,value:threePosition(v)}}  }
    ],
    [
        { name: "爆珠棒", value: 4987, color: theme.color.primary, type:"爆珠棒", format: (v,name) => { return {name:name,value:threePosition(v)}}},
        { name: "高透棒", value: 2532, color: theme.color.warning, type:"高透棒" , format: (v,name) => { return {name:name,value:threePosition(v)}}  },
        { name: "中空拉丝棒", value: 3680, color: theme.color.pink, type:"中空拉丝棒" , format: (v,name) => { return {name:name,value:threePosition(v)}}  },
        { name: "二元复合棒", value: 1738, color: theme.color.danger, type:"二元复合棒", format: (v,name) => { return {name:name,value:threePosition(v)}}  },
        { name: "三元复合棒", value: 2590, color: theme.color.green, type:"三元复合棒", format: (v,name) => { return {name:name,value:threePosition(v)}} },
        { name: "四元复合棒", value: 1276, color: theme.color.gray, type:"四元复合棒" , format: (v,name) => { return {name:name,value:threePosition(v)}}  }
    ],
];
